/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-11 11:51:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';

import OldMenu from 'src/components/containers/main-menu-old';
import MainMenuItem from './item';

import { getMenuLeft, getMenuRight } from 'src/helpers/menu-helper.js';
import { allowUsingNewSearchSettings } from 'src/helpers/search-settings-helper';
import { enableShopifyIntegration } from 'src/helpers/theme-setup-helper';
import { ComposedProps } from './index.type';
import { checkUserEnableShowAppVersionSwitching } from 'src/helpers/account-helper';

//-----------------------------------------
const MainMenu = (props: ComposedProps) => {
  const { i18n, tenantApp, menuId = '', themeSetupV2 = false, isNewSearch } = props;
  const isEnableShopifyIntegration = enableShopifyIntegration(tenantApp);

  if (!isNewSearch) return <OldMenu menuId={menuId} />;
  const menuLeft = getMenuLeft(i18n, { hideAISearch: !isNewSearch, themeSetupV2 });
  const menuRight = getMenuRight(i18n, {
    themeSetupV2,
    hasShopifyIntegration: isEnableShopifyIntegration,
    enableAppVersionSwitching: checkUserEnableShowAppVersionSwitching(tenantApp)
  });

  return (
    <React.Fragment>
      <div className="PFS_MainMenu_Wrapper">
        <div className="PFS_MainMenu">
          <div className="menu-features">
            {menuLeft.map(menuItem => (
              <MainMenuItem key={menuItem.id} menuId={menuId} data={menuItem} position="left" />
            ))}
          </div>
          <div className="menu-settings">
            {menuRight.map(menuItem => (
              <MainMenuItem key={menuItem.id} menuId={menuId} data={menuItem} position="right" />
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const tenantAppSettings = _.get(state.oauth, 'tenantApp.settings', {});
  const themeSetupV2 = _.get(tenantApp, 'adminAppFeatures.themeSetupV2', false);
  const searchVersion = _.get(state.oauth, 'tenantApp.parseParams.searchVersion', '1.0');
  const isNewSearch = allowUsingNewSearchSettings(searchVersion);

  return {
    tenantApp,
    tenantAppSettings,
    themeSetupV2: themeSetupV2,
    isNewSearch
  };
};

export default connect(mapStateToProps)(withI18n()(MainMenu));
